/**
 * Watrly i18n System
 * ==================
 * نظام اللغات والترجمة
 */

import { ar } from './ar';
import { en } from './en';

export const translations = {
  ar,
  en,
};

export const defaultLocale = 'ar';
export const supportedLocales = ['ar', 'en'];

export const localeConfig = {
  ar: {
    name: 'العربية',
    nameEn: 'Arabic',
    dir: 'rtl',
    flag: '🇸🇦',
  },
  en: {
    name: 'English',
    nameEn: 'English',
    dir: 'ltr',
    flag: '🇬🇧',
  },
};

/**
 * الحصول على ترجمة من مسار محدد
 * @param {string} path - مسار الترجمة مثل 'general.save'
 * @param {string} locale - اللغة المطلوبة
 * @param {object} params - المعاملات للاستبدال
 */
export function t(path, locale = defaultLocale, params = {}) {
  const keys = path.split('.');
  let value = translations[locale];

  for (const key of keys) {
    if (value && typeof value === 'object' && key in value) {
      value = value[key];
    } else {
      // إذا لم توجد الترجمة، جرب اللغة الافتراضية
      value = translations[defaultLocale];
      for (const k of keys) {
        if (value && typeof value === 'object' && k in value) {
          value = value[k];
        } else {
          return path; // إرجاع المسار كما هو إذا لم توجد ترجمة
        }
      }
      break;
    }
  }

  // استبدال المعاملات
  if (typeof value === 'string' && Object.keys(params).length > 0) {
    Object.entries(params).forEach(([key, val]) => {
      value = value.replace(new RegExp(`{${key}}`, 'g'), val);
    });
  }

  return value;
}

export { ar, en };
export default translations;
